import { type ReactNode } from "react";
import { MotionConfig } from "framer-motion";
import { ease } from "@/lib/motion";
import { QueryClientProvider } from "@tanstack/react-query";
import { AppThemeProvider } from "@/lib/mui/AppThemeProvider";
import { Toaster } from "sonner";
import { queryClient } from "./queryClient";
import { GoogleTranslation } from "@/components/GoogleTranslation";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion="user" transition={ease}>
        <GoogleTranslation />
        <AppThemeProvider>
          {children}
          <Toaster position="top-right" richColors closeButton />
        </AppThemeProvider>
      </MotionConfig>
    </QueryClientProvider>
  );
}
